import { IAppProps, IAppProviderState, SCREEN_NAME } from '../interface/IAppProvider';
import { getDataToObjectCache, sendDataToObjectCache } from '../async/AsyncCalls';
import { setSessionItem, getSessionItem } from '../services/StorageService';
import { TDispatch } from '../context/AppContext';

/**
 * Save data to cache and return key string
 */
interface IObjectCacheResp {
    objectId: string;
}
export const saveToObjectCache = async (props: IAppProps, state: IAppProviderState, appDispatch: TDispatch) => {
    appDispatch({ type: SCREEN_NAME.LOADING_DATA, payload: true });
    try {
        sendDataToObjectCache(props, appDispatch, {
            data: updateObject(state)
        }).then((response: IObjectCacheResp) => {
            setSessionItem('onsa-content-cache-key', response.objectId);
            appDispatch({ type: SCREEN_NAME.LOADING_DATA, payload: false });
        });
    } catch (e) {
        props.c9log.error(`${e}: Something went wrong trying to save the data to cache`, 'Actions');
    }
};

/**
 * Save data to cache and return key string
 */
export const reloadApplicationStateFromCache = async (props: IAppProps, appDispatch: TDispatch) => {
    try {
        const key = getSessionItem('onsa-content-cache-key');
        if (key) {
            const response = await getDataToObjectCache(props, appDispatch, key);
            const stateFromObjectCache = response.object;
            appDispatch({ type: SCREEN_NAME.RELOAD_STATE, payload: stateFromObjectCache });
            appDispatch({ type: SCREEN_NAME.SET_INITIAL_STATE, payload: false });
            appDispatch({ type: SCREEN_NAME.SET_STATE_CHANGE, payload: false });
            appDispatch({ type: SCREEN_NAME.REFRESH_FROM_CACHE, payload: true });
        } else {
            appDispatch({ type: SCREEN_NAME.REFRESH_FROM_CACHE, payload: true });
        }
    } catch (error) {
        appDispatch({ type: SCREEN_NAME.SET_ERROR, payload: true });
    }
};

/**
 * Remove resource bundles
 */
export const updateObject = (globalState: IAppProviderState) => {
    const stateCopy = { ...globalState };
    //Match with initial state for browser refresh
    stateCopy.refreshFromCache = false;
    stateCopy.resourcesReady = false;
    stateCopy.section = null;
    stateCopy.contentBlocks = {};
    return stateCopy;
};
